// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookLibrary_book_slider_container__WmgA9 {
    padding: 0px;
    max-width: 95%;
    margin: 0 auto;
  }
  .BookLibrary_heading__Tb16m{
    color: white;
    font-size: 20px;
  }
  .BookLibrary_author_header__95fne{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .BookLibrary_author_header__95fne span{
    color: white;
    cursor: pointer;
  }
  
  .BookLibrary_book_card__0YtI8 {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
  }
  
  .BookLibrary_book_card__0YtI8:hover {
    transform: translateY(-5px);
  }
  
  .BookLibrary_book_image__cXGWE {
    width: 100%;
    min-height: auto;
    border-radius: 4px;
    object-fit: cover;
  }
  
  .BookLibrary_book_title__sQbKm {
    margin-top: 10px;
    font-size: 16px;
    text-align: center;
    color: #333;
  }
  
  /* Swiper custom styles */
  .BookLibrary_swiper-button-next__k-GS4,
  .BookLibrary_swiper-button-prev__pqLJU {
    color: #333;
  }
  
  .BookLibrary_swiper-pagination-bullet-active__xWz9- {
    background: #333;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .BookLibrary_book_slider_container__WmgA9 {
      padding: 0px;
    }
    
    .BookLibrary_book_title__sQbKm {
      font-size: 14px;
    }
    .BookLibrary_book_image__cXGWE {
      min-height: 120px;
    }
  }
  
  @media (max-width: 480px) {
    .BookLibrary_book_card__0YtI8 {
      padding: 5px;
    }
    .BookLibrary_book_slider_container__WmgA9 {
      padding: 0px;
    }
    .BookLibrary_heading__Tb16m{
      font-size: 18px;
    }
    .BookLibrary_book_title__sQbKm {
      font-size: 12px;
    }
    .BookLibrary_book_image__cXGWE{
      height: 180px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/BookLibrary.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA,yBAAyB;EACzB;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;;EAEF","sourcesContent":[".book_slider_container {\n    padding: 0px;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  .heading{\n    color: white;\n    font-size: 20px;\n  }\n  .author_header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .author_header span{\n    color: white;\n    cursor: pointer;\n  }\n  \n  .book_card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n  }\n  \n  .book_card:hover {\n    transform: translateY(-5px);\n  }\n  \n  .book_image {\n    width: 100%;\n    min-height: auto;\n    border-radius: 4px;\n    object-fit: cover;\n  }\n  \n  .book_title {\n    margin-top: 10px;\n    font-size: 16px;\n    text-align: center;\n    color: #333;\n  }\n  \n  /* Swiper custom styles */\n  .swiper-button-next,\n  .swiper-button-prev {\n    color: #333;\n  }\n  \n  .swiper-pagination-bullet-active {\n    background: #333;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .book_slider_container {\n      padding: 0px;\n    }\n    \n    .book_title {\n      font-size: 14px;\n    }\n    .book_image {\n      min-height: 120px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .book_card {\n      padding: 5px;\n    }\n    .book_slider_container {\n      padding: 0px;\n    }\n    .heading{\n      font-size: 18px;\n    }\n    .book_title {\n      font-size: 12px;\n    }\n    .book_image{\n      height: 180px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"book_slider_container": `BookLibrary_book_slider_container__WmgA9`,
	"heading": `BookLibrary_heading__Tb16m`,
	"author_header": `BookLibrary_author_header__95fne`,
	"book_card": `BookLibrary_book_card__0YtI8`,
	"book_image": `BookLibrary_book_image__cXGWE`,
	"book_title": `BookLibrary_book_title__sQbKm`,
	"swiper-button-next": `BookLibrary_swiper-button-next__k-GS4`,
	"swiper-button-prev": `BookLibrary_swiper-button-prev__pqLJU`,
	"swiper-pagination-bullet-active": `BookLibrary_swiper-pagination-bullet-active__xWz9-`
};
export default ___CSS_LOADER_EXPORT___;
